import React, { useState, useEffect } from 'react';
// import { Link } from 'react-router-dom';
let api = 'https://whiskey-api.herokuapp.com';
// let PORT= 'http://localhost:3000'

export default function TeachingShow(props) {
  console.log(props.match.params.id)
  const [teaching, showTeaching] = useState({});
  
  const getTeaching = async() =>{
    try {
      const response = await fetch(/*`${endpoint}/${props.match.params.id}`*/ `${api}/teachings/${props.match.params.id}`);
      const data = await response.json();
      await showTeaching(data);
      console.log(response)
      console.log(teaching)
      console.log(data)
    } catch (e) {
      console.error(e);
    }
  }
	useEffect(() => {	
  getTeaching();
  // eslint-disable-next-line react-hooks/exhaustive-deps
  },[]);
  
  return(
    <div>
      
      <h1>Teaching Show Page</h1>
    {Object.keys.length > 0 ? (
      <div>
        <h1>{teaching.title}</h1>
        <h3>{teaching.temptation}</h3>
        <h3>{teaching.bibleVerse}</h3>
        <h3>CCC #{teaching.cccParagraph}</h3>
        <article>
          <p>{teaching.reading}</p>
          <p>{teaching.prayer}</p>
        </article>
        
      </div>
    ) : (
      <h1>Nothing found on {props.match.params.id}.</h1>
    )}
  </div>
  )
  }